import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PageContent, PageTitle, Button, Link } from 'nallian-shared-ui/lib/components';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { Table, Params, Actions, Menu } from 'nallian-table-builder-ui';
import NewRelationType from './NewRelationType';
import EditRelationType from './EditRelationType';
import { INFINITE_SCROLL, RELATION_TYPES_RESOURCE, ACTIONS, SORTED } from '../constants';
import apiRoutes from '../../../app/api/routes';

const RELATION_TYPES_RIGHTS = ['RELATIONTYPES.MANAGE.ALL', 'RELATIONTYPES.MANAGE.ALL'];

const RelationTypesOverview = () => {
  const { t } = useTranslation();
  const { id, action } = useParams();

  return (
    <>
      <PageTitle>{t('relationTypes_plural')}</PageTitle>
      <PageContent>
        <HasRight right="RELATIONTYPES.MANAGE.ALL">
          <>
            <NewRelationType open={!id && action === ACTIONS.NEW} />
            <Link to={`/relation-types/${ACTIONS.NEW}`}>
              <Button icon="add" content={t('newRelationType')} btnprimary />
            </Link>
          </>
        </HasRight>
        <EditRelationType open={id && action === ACTIONS.EDIT} />
        <Table
          url={apiRoutes.relationTypes()}
          infiniteScroll={INFINITE_SCROLL}
          resource={RELATION_TYPES_RESOURCE}
          sorted={SORTED}
          pageSize={50}
          idProp="id"
          noUserSettings
          resizable
          filtered
        >
          <Actions.Link
            width="2.5rem"
            align="center"
            icon="eye"
            hasSomeRights={RELATION_TYPES_RIGHTS}
            url={`/relation-types/${ACTIONS.EDIT}/:id`}
          />
          <Params.String name="name" width="16rem" minWidth="16rem" grow />
          <Params.String name="tag" width="16rem" minWidth="16rem" grow />
          <Params.Bool name="isGloballyManaged" width="16rem" minWidth="16rem" grow />
          <Menu width="3.5rem" align="center" hasRight="RELATIONTYPES.MANAGE.ALL">
            <Actions.Link label="edit" icon="edit" url={`/relation-types/${ACTIONS.EDIT}/:id`} />
            <Actions.Delete url={`${apiRoutes.relationTypes()}/:id`} />
          </Menu>
        </Table>
      </PageContent>
    </>
  );
};

export default RelationTypesOverview;
